document.addEventListener("turbo:load", function() {
  $("#user-sign-in").on("ajax:beforeSend", function(event) {
    const xhr = event.detail[0];
    xhr.setRequestHeader('JWT-AUD', 'cybros');
  });
});
